<script>
  import { sessionStore, settingsStore } from '../stores';
  import { request } from '../utils/request';
  import { requestLogin } from '../utils/authSession';
  import { assertServiceAvailable } from '../utils/serviceAvailability';
  import { serviceStore } from '../stores/serviceStore';
  import { mbtiJobs } from '../utils/styleCatalog';
  import { tick } from 'svelte';
  let dogName = '토리', userName = $sessionStore.name || '친구', mbti = $settingsStore.mbtiType || 'ENFP';
  let messages = [], draft = '', busy = false, error = '', thread;
  async function send() {
    if (!draft.trim() || busy) return;
    if (!await requestLogin('반려견과 대화하려면 로그인해 주세요.')) return;
    busy = true; error = '';
    const message = { role: 'user', content: draft.trim() };
    const previous = messages;
    messages = [...messages, message]; draft = '';
    await tick(); thread?.scrollTo({ top: thread.scrollHeight, behavior: 'smooth' });
    try {
      await assertServiceAvailable();
      const result = await request('/api/dog_chat', { method: 'POST', signal: AbortSignal.timeout(60000), body: { dog_name: dogName, user_name: userName, mbti, messages: messages.slice(-20) } });
      if (!result.answer?.trim()) throw new Error('답변을 받지 못했습니다. 다시 시도해 주세요.');
      messages = [...messages, { role: 'assistant', content: result.answer }];
      await tick(); thread?.scrollTo({ top: thread.scrollHeight, behavior: 'smooth' });
    } catch (e) { messages = previous; draft = message.content; error = e.message; }
    finally { busy = false; }
  }
</script>
<div class="dog-chat">
  <h1>반려견과 대화하기</h1><p>우리 아이의 MBTI를 담아 나누는 상상 속 대화예요.</p>
  <div class="profile">
    <label>반려견 이름 <input bind:value={dogName} maxlength="20" disabled={busy || messages.length > 0} /></label>
    <label>내 이름 <input bind:value={userName} maxlength="20" disabled={busy || messages.length > 0} /></label>
    <label>MBTI <select bind:value={mbti} disabled={busy || messages.length > 0}>{#each Object.entries(mbtiJobs) as [type, job]}<option value={type}>{type} · {job}</option>{/each}</select></label>
    <button disabled={busy} on:click={() => { if (!messages.length || confirm('대화를 지우고 다시 시작할까요?')) { messages = []; error = ''; } }}>새 대화</button>
  </div>
  <div class="thread" bind:this={thread} role="log" aria-live="polite" aria-label="대화 내용">
    {#if !messages.length}<p class="greeting">{dogName || '우리 아이'}에게 오늘 하고 싶은 이야기를 들려주세요.</p>{/if}
    {#each messages as message}<div class="message" class:mine={message.role === 'user'}><strong>{message.role === 'user' ? userName : dogName}</strong><p>{message.content}</p></div>{/each}
    {#if busy}<p role="status">답변을 생각하고 있어요...</p>{/if}
  </div>
  {#if error}<p role="alert">{error}</p>{/if}
  <form on:submit|preventDefault={send}><label class="composer">메시지 <textarea bind:value={draft} placeholder="오늘 산책 어땠어?" maxlength="2000" rows="2" disabled={busy}></textarea></label><button type="submit" disabled={busy || !draft.trim() || $serviceStore.blocksNewRequests}>보내기</button></form>
</div>
<style>
  .dog-chat { max-width: 900px; margin: 32px auto; } h1 { color: #e56831; } p { line-height: 1.7; }
  .profile, form { display: flex; gap: 12px; align-items: end; flex-wrap: wrap; } label { display: grid; gap: 8px; }
  input, select, textarea, button { background: transparent; color: inherit; border: 1px solid #8885; border-radius: 10px; padding: 10px; font: inherit; }
  select { max-width: 100%; } select option { color: #333; background: #fff; } button { cursor: pointer; } button:disabled { opacity: .5; }
  .thread { height: 50dvh; min-height: 280px; overflow-y: auto; padding: 20px; margin: 24px 0; border: 1px solid #8883; border-radius: 18px; display: flex; flex-direction: column; gap: 16px; }
  .greeting { text-align: center; margin: auto; opacity: .7; } .message { align-self: start; max-width: 85%; padding: 14px 18px; background: #8881; border-radius: 16px; }
  .message.mine { align-self: end; background: #fe6a371a; } .message p { margin: 6px 0 0; white-space: pre-wrap; overflow-wrap: anywhere; } .composer { flex: 1; min-width: 180px; } [role=alert] { color: #cb4933; }
</style>
